import type { MantineSpacing } from '@mantine/core'
import { Box, Group, Stack, Text } from '@mantine/core'
import type { ReactNode } from 'react'

import { theme } from '@/configs/theme'
import useCheckMobileScreen from '@/hooks/useCheckMobileScreen'
import * as classes from '@/styles/TableContentGrid.css'
import type { StringWithAutocomplete } from '@/types/helpers'

type TableContentGridRow = {
  id?: string
  heading: ReactNode
  content: ReactNode
  headingVerticalAlign?: 'top' | 'middle'
}

type TableContentGridProps = {
  rows: TableContentGridRow[]
  spacing?: MantineSpacing
  headingFlexWidth?: StringWithAutocomplete<'auto'>
}

export function TableContentGrid(props: TableContentGridProps) {
  const { rows, spacing = 'lg', headingFlexWidth = 'auto' } = props
  const isMobile = useCheckMobileScreen()

  return (
    <Box>
      {rows.map((row, index) => (
        <Group
          key={row.id || index}
          className={classes.row}
          gap={0}
          wrap={isMobile ? 'wrap' : 'nowrap'}
          justify="flex-start"
          align="stretch">
          <Stack
            p={isMobile ? 'sm' : spacing}
            pb={isMobile ? 0 : undefined}
            justify={isMobile ? 'flex-start' : row.headingVerticalAlign === 'top' ? 'flex-start' : 'center'}
            align={isMobile ? 'flex-start' : 'center'}
            flex={isMobile ? '1 0 100%' : `0 0 ${headingFlexWidth}`}
            className={theme.cx(classes.headingCell, isMobile && classes.headingCellMobile)}>
            {typeof row.heading === 'string' ? (
              <Text size="sm" fw={600} ta={isMobile ? 'left' : 'center'}>
                {row.heading}
              </Text>
            ) : (
              row.heading
            )}
          </Stack>

          <Box p={isMobile ? 'sm' : spacing} pt={isMobile ? 'xs' : undefined} flex="1 1 auto" miw={0}>
            {typeof row.content === 'string' ? <Text>{row.content}</Text> : row.content}
          </Box>
        </Group>
      ))}
    </Box>
  )
}
